import {
  AcademicStatusLabel,
  AcademicStatusType,
} from '@/models/learning/academic-situation';

type StatusPaletteKey = 'info' | 'warning' | 'success' | 'error' | 'neutral';

interface StatusAction {
  label: string;
  variant: 'contained' | 'outlined';
  expandForm?: boolean;
}

interface StatusConfig {
  label: AcademicStatusLabel;
  palette: StatusPaletteKey;
  backgroundColor: string;
  color: string;
  banner?: string;
  action?: StatusAction;
}

const navigate = (
  label: string,
  variant: 'contained' | 'outlined',
  expandForm = false
): StatusAction => ({ label, variant, expandForm });

export const academicStatusConfig: Record<AcademicStatusType, StatusConfig> = {
  [AcademicStatusType.Pending]: {
    label: AcademicStatusLabel.Pending,
    palette: 'info',
    backgroundColor: 'info.light',
    color: 'info.dark',
    banner: 'Atualizaremos o status de sua inscrição em até 24 horas.',
    action: navigate('Ver detalhes', 'outlined'),
  },
  [AcademicStatusType.EnrollmentPending]: {
    label: AcademicStatusLabel.EnrollmentPending,
    palette: 'warning',
    backgroundColor: 'warning.light',
    color: 'warning.dark',
    banner: 'Envie um comprovante de matrícula.',
    action: navigate('Enviar comprovante', 'contained', true),
  },
  [AcademicStatusType.InProgress]: {
    label: AcademicStatusLabel.InProgress,
    palette: 'info',
    backgroundColor: 'info.light',
    color: 'info.dark',
    action: navigate('Atualizar andamento', 'outlined', true),
  },
  [AcademicStatusType.Interrupted]: {
    label: AcademicStatusLabel.Interrupted,
    palette: 'error',
    backgroundColor: 'error.light',
    color: 'error.dark',
    action: navigate('Ver detalhes', 'outlined'),
  },
  [AcademicStatusType.Canceled]: {
    label: AcademicStatusLabel.Canceled,
    palette: 'neutral',
    backgroundColor: 'neutral.lighter',
    color: 'neutral.dark',
  },
  [AcademicStatusType.Completed]: {
    label: AcademicStatusLabel.Completed,
    palette: 'success',
    backgroundColor: 'success.light',
    color: 'success.dark',
    banner: 'Envie um comprovante de conclusão de curso.',
    action: navigate('Enviar comprovante', 'contained', true),
  },
};
